import { InferValuesTypes } from '@yandex-int/k-common/typings';
import { SUBJECTS_SLUGS_TYPE } from 'platform-components/src/typings';

import * as actions from './actions';

export const MAX_CLASS_NAME_LENGTH = 10;
export const MS_IN_DAY = 24 * 60 * 60 * 1000;

export interface iSourceSchoolbook {
    author: string;
    subject: SUBJECTS_SLUGS_TYPE;
    grades?: Array<number>;
}

export interface iSchoolbook extends iSourceSchoolbook {
    id: string;
    umk: string;
}

// FIXME: typescript. Использовать <T extends iSchoolbook | iSourceSchoolbook>
export interface iUMK<T> {
    label: string;
    schoolbooks: Array<T>;
}

export interface UMKModalSubjectData {
    selectedSchoolbookId: string | null;
    query: string | null;
}

export interface UMKModalStoreState {
    // @ts-ignore
    [subject: string]: UMKModalSubjectData;
}

export type UMKModalAction = ReturnType<InferValuesTypes<typeof actions>>;
